module.exports = __webpack_public_path__ + "static/media/seat.5305acf5.jpg";